import { initCalendarMailboxConfiguration } from 'owa-calendar-configuration';
import initBirthdayCalendarOption from 'owa-calendar-birthday-option/lib/orchestration/initBirthdayCalendarOption';
import { trace } from 'owa-trace';

export default async function initializeViewSubCategory(): Promise<boolean> {
    try {
        await Promise.all([initCalendarMailboxConfiguration(), initBirthdayCalendarOption()]);
        return true;
    } catch (e) {
        trace.warn(e.message || 'initializeViewSubCategory failed');
        return false;
    }
}
